import O_CapsulePostHeader from './O_CapsulePostHeader';
import O_CapsulePostHeaderMobile from './O_CapsulePostHeaderMobile';
import { useIsMobile } from '@/hooks/useIsMobile';
import { CapsuleViewMode } from '@/components/capsule-view/constants';

interface O_CapsulePostHeaderResponsiveProps {
  onToggleExpanded: () => void;
  isExpanded: boolean;
  onOpenPostMenu?: () => void;
  selectedView?: CapsuleViewMode;
  onViewSelect?: (view: CapsuleViewMode) => void;
  showActionsMenu?: boolean;
  onDelete?: () => void;
  capsuleId?: string;
}

export default function O_CapsulePostHeaderResponsive({
  onToggleExpanded,
  isExpanded,
  onOpenPostMenu,
  selectedView,
  onViewSelect,
  showActionsMenu,
  onDelete,
  capsuleId,
}: O_CapsulePostHeaderResponsiveProps) {
  const isMobile = useIsMobile(1080);

  if (isMobile) {
    return (
      <O_CapsulePostHeaderMobile
        onOpenPostMenu={onOpenPostMenu}
        selectedView={selectedView}
        onViewSelect={onViewSelect}
        showActionsMenu={showActionsMenu}
        onDelete={onDelete}
        capsuleId={capsuleId}
      />
    );
  }

  return (
    <O_CapsulePostHeader
      onToggleExpanded={onToggleExpanded}
      isExpanded={isExpanded}
    />
  );
}
